"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEFT = void 0;
exports.LEFT = {
    alias: 'ESQUERDA',
    description: 'Retorna os primeiros caracteres de uma string baseado no número de caracteres especificado',
    arg_names: ['string_para_extrair', 'numero_de_caracteres'],
    args_description: [
        'o texto que contém os caracteres que deseja extrair',
        'o número de caracteres para serem extraidos',
    ],
};
